import React from 'react';
import '../../css/Settings.css';


function LogoGallery({ logoOptions, selectedLogo, onSelectLogo }) {
  return (
    <div className="logo-gallery">
      {logoOptions.map((logo, index) => (
        <div
          key={index}
          className={`logo-thumbnail ${selectedLogo === logo ? 'selected' : ''}`}
          onClick={() => onSelectLogo(logo)}
        >
          <img src={logo} alt={`Logo ${index + 1}`} />
        </div>
      ))}
    </div>
  );
}

export default LogoGallery;
